// extracted by mini-css-extract-plugin
export default {"editProperty":"PropertyDataModal_editProperty__hAaNt","btn":"PropertyDataModal_btn__nw1Qm","flex":"PropertyDataModal_flex__xdbMD","button":"PropertyDataModal_button__syiaD"};